import React, { useState } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { useCart } from './CartContext';
// ➡️ Import the useApi hook
import { useApi } from './ApiContext'; 

import './Login.css';

// axios.defaults.withCredentials = true; is important for session handling
axios.defaults.withCredentials = true;

const Login = () => {
  // ➡️ Access the API_BASE_URL from ApiContext
  const { API_BASE_URL } = useApi();
  // API Endpoints
  const LOGIN_API = `${API_BASE_URL}/login`;

  const [username, setUsernameInput] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const { checkAuth } = useAuth();
  const { fetchCartFromBackend } = useCart();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!username || !password) {
      setError('Please fill in all fields');
      return;
    }
    
    // ➡️ Safeguard: Check if API_BASE_URL is available
    if (!API_BASE_URL) {
      setError('Configuration error. API URL is missing.');
      return;
    }

    setLoading(true);
    setError('');

    try {
      // ➡️ Use the dynamic LOGIN_API
      const response = await axios.post(
        LOGIN_API,
        { username, password }
      );

      if (response.data.success) {
        await checkAuth(); // updates auth context
        await fetchCartFromBackend(); // refresh cart without reload
        history.push('/dashboard');
      } else {
        setError(response.data.message || 'Login failed');
      }
    } catch (err) {
      console.error('Login error:', err);
      // axios errors have a specific response structure
      setError(err.response?.data?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="base-login">
      <div className="login-container">
        <h2>Login</h2>
        {error && <p className="error">{error}</p>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsernameInput(e.target.value)}
              disabled={loading}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={loading}
              required
            />
          </div>

          {/* ➡️ TAMBAHAN: Pautan Forgot Password */}
          <div className="forgot-password-link">
            <span onClick={() => history.push('/forgot-password')}>
              Forgot Password?
            </span>
          </div>

          <button 
            className="login-button" 
            type="submit" 
            disabled={loading}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <p className="auth-switch">
          Don't have an account?{' '}
          <span onClick={() => history.push('/signup')}>Click Here</span>
        </p>
      </div>
    </div>
  );
};

export default Login;